// extracted by mini-css-extract-plugin
export default {"saml_consume_loader":"samlConsume_saml_consume_loader__ZQHLY"};